"use client";
import { useRouter } from "next/navigation";
import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";

const dashboardFor: Record<string, string> = {
  student: "/student",
  teacher: "/teacher",
  country_admin: "/country-admin",
  super_admin: "/super-admin/dashboard",
};

export default function NotFound() {
  const { user, isLoading } = useAuth();
  const router = useRouter();

  const dest = user ? (dashboardFor[user.role] ?? "/") : "/";
  const label = user ? "Go to Dashboard" : "Go to Home";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-muted/40">
      <h1 className="text-6xl font-bold text-foreground">404</h1>
      <p className="text-muted-foreground">This page doesn't exist.</p>
      <Button disabled={isLoading} onClick={() => router.replace(dest)}>
        {isLoading ? "Loading..." : label}
      </Button>
    </div>
  );
}
